export enum LeaveApprovalStatusEnum {
    OPEN = 'OPEN',
    APPROVED = 'APPROVED',
    REJECTED = 'REJECTED',
    CANCEL = 'CANCEL'
}